import { render, staticRenderFns } from "./SBFaqTitle.html?vue&type=template&id=7294838a&scoped=true&"
import script from "./SBFaqTitle.ts?vue&type=script&lang=ts&"
export * from "./SBFaqTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SBFaqTitle.css?vue&type=style&index=0&id=7294838a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294838a",
  null
  
)

export default component.exports